// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NXOQ","newExpiryDate":"styles_newExpiryDate__36T3U","footer":"styles_footer__2wLj7"};